
var Globalize = require('globalize/dist/globalize-runtime');
require('globalize/dist/globalize-runtime/number');
require('globalize/dist/globalize-runtime/plural');
require('globalize/dist/globalize-runtime/message');
require('globalize/dist/globalize-runtime/date');
var validateParameterTypeNumber = Globalize._validateParameterTypeNumber;
var validateParameterPresence = Globalize._validateParameterPresence;
var numberRound = Globalize._numberRound;
var numberFormat = Globalize._numberFormat;
var numberFormatterFn = Globalize._numberFormatterFn;
var validateParameterTypeString = Globalize._validateParameterTypeString;
var numberParse = Globalize._numberParse;
var numberParserFn = Globalize._numberParserFn;
var pluralGeneratorFn = Globalize._pluralGeneratorFn;
var validateParameterTypeMessageVariables = Globalize._validateParameterTypeMessageVariables;
var messageFormat = Globalize._messageFormat;
var messageFormatterFn = Globalize._messageFormatterFn;
var validateParameterTypeDate = Globalize._validateParameterTypeDate;
var dateToPartsFormat = Globalize._dateToPartsFormat;
var dateToPartsFormatterFn = Globalize._dateToPartsFormatterFn;
var dateFormat = Globalize._dateFormat;
var dateFormatterFn = Globalize._dateFormatterFn;
var dateTokenizer = Globalize._dateTokenizer;
var dateParse = Globalize._dateParse;
var dateParserFn = Globalize._dateParserFn;

Globalize.a1606075732 = numberFormatterFn(["",,2,0,0,,,,,,"","00","-00","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.a1556101844 = numberFormatterFn(["",,4,0,0,,,,,,"","0000","-0000","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.a1575818880 = numberFormatterFn(["",,1,0,0,,,,,,"","0","-0","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b1684012025 = numberParserFn([{",":".",".":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},,{"infinity":/^∞/,"nan":/^NaN/,"negativePrefix":/^-/,"negativeSuffix":/^/,"number":/^\d+/,"prefix":/^/,"suffix":/^/}]);
Globalize.b1184609144 = pluralGeneratorFn(function(n
) {
  var s = String(n).split('.'), i = s[0], t0 = Number(s[0]) == n;
  return (n == 1 || !t0 && (i == 0
          || i == 1)) ? 'one' : 'other';
});
Globalize.a501063466 = messageFormatterFn((function(  ) {
  return function(d) { return "Log på"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1733559904 = messageFormatterFn((function(  ) {
  return function(d) { return "Log på"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1620006517 = messageFormatterFn((function(  ) {
  return function(d) { return "E-mailadresse"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b941513746 = messageFormatterFn((function(  ) {
  return function(d) { return "Adgangskode"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1873806195 = messageFormatterFn((function(  ) {
  return function(d) { return "Dette er en offentlig eller delt enhed"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a2104695494 = messageFormatterFn((function(  ) {
  return function(d) { return "Er det ikke din enhed? Når du markerer dette afkrydsningsfelt, reduceres den tid, du er logget ind her, før du automatisk bliver logget af."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1700338975 = messageFormatterFn((function(  ) {
  return function(d) { return "Forbliv logget på"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1474965571 = messageFormatterFn((function(  ) {
  return function(d) { return "Markerer du dette afkrydsningsfelt, forbliver du logget på din konto på denne enhed, indtil du logger af. Marker ikke afkrydsningsfeltet på delte enheder."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a18350965 = messageFormatterFn((function(  ) {
  return function(d) { return "Glemt din adgangskode?"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a858540538 = messageFormatterFn((function(  ) {
  return function(d) { return "Fortsæt"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1720117939 = messageFormatterFn((function(  ) {
  return function(d) { return "Annuller"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a879106972 = messageFormatterFn((function(  ) {
  return function(d) { return "Gå tilbage"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a542691230 = messageFormatterFn((function(  ) {
  return function(d) { return "Genindlæs"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b517660189 = messageFormatterFn((function(  ) {
  return function(d) { return "Ved at logge på accepterer jeg " + d["0"] + "s <a href=" + d["1"] + " " + d["3"] + ">vilkår og betingelser</a> samt <a href=" + d["2"] + " " + d["4"] + ">privatlivspolitik</a>."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b557115553 = messageFormatterFn((function(  ) {
  return function(d) { return "Ved at logge på accepterer jeg " + d["0"] + "s <a href=" + d["1"] + " " + d["5"] + ">vilkår og betingelser</a>, <a href=" + d["2"] + " " + d["6"] + ">privatlivspolitik</a> samt <a href=" + d["3"] + " " + d["7"] + ">vilkår og betingelser for " + d["4"] + "</a>."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a829711513 = messageFormatterFn((function(  ) {
  return function(d) { return "Ved at logge på tilmelder jeg mig også " + d["4"] + ". Jeg accepterer " + d["0"] + "s <a href=" + d["1"] + " " + d["5"] + ">vilkår og betingelser</a>, <a href=" + d["2"] + " " + d["6"] + ">privatlivspolitik</a> samt <a href=" + d["3"] + " " + d["7"] + ">vilkår og betingelser for " + d["4"] + "</a>."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a364683758 = messageFormatterFn((function(  ) {
  return function(d) { return "Din konto blev sat på pause i forbindelse med et rutinemæssigt sikkerhedstjek. Dine oplysninger er sikre, men du skal nulstille din adgangskode. Klik på \"Glemt din adgangskode?\" nedenfor for at ændre koden og logge på."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1717463876 = messageFormatterFn((function(  ) {
  return function(d) { return "E-mailadressen og adgangskoden stemmer ikke overens. Prøv igen."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1505255009 = messageFormatterFn((function(  ) {
  return function(d) { return "Der er desværre opstået en fejl."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a379982053 = messageFormatterFn((function(  ) {
  return function(d) { return "Der er desværre opstået en fejl. Vent et øjeblik, og prøv igen."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1047422717 = messageFormatterFn((function(  ) {
  return function(d) { return "Indtast din e-mailadresse."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1089857684 = messageFormatterFn((function(  ) {
  return function(d) { return "Indtast en gyldig e-mailadresse."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1528856474 = messageFormatterFn((function(  ) {
  return function(d) { return "Indtast din adgangskode."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b398454000 = messageFormatterFn((function(  ) {
  return function(d) { return "Kontrollerer loginoplysninger..."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1449195317 = messageFormatterFn((function(  ) {
  return function(d) { return "Skjul adgangskode"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1763537456 = messageFormatterFn((function(  ) {
  return function(d) { return "Vis adgangskode"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1985699058 = messageFormatterFn((function(  ) {
  return function(d) { return "Har du ikke en konto? <span><a id=\"createAcctRedirectLink\" href=" + d["0"] + ">Opret en her</a></span>"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1262588499 = messageFormatterFn((function(  ) {
  return function(d) { return "Log på"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a2122024374 = messageFormatterFn((function(  ) {
  return function(d) { return "Det er ikke længere muligt at logge på via " + d["0"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1942841318 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kan bruge denne samme e-mailadresse til at logge på din " + d["0"] + "-konto ved at nulstille adgangskoden. Det har ingen indflydelse på din " + d["1"] + "-konto."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a571444424 = messageFormatterFn((function(  ) {
  return function(d) { return "Nulstil din adgangskode ved at klikke på knappen nedenfor. Næste gang du logger på " + d["0"] + ", kan du bruge din e-mailadresse og din nye adgangskode."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1941422143 = messageFormatterFn((function(  ) {
  return function(d) { return "Log på med SSO"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1741512009 = messageFormatterFn((function(  ) {
  return function(d) { return "Log på med single sign-on"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1986596917 = messageFormatterFn((function(  ) {
  return function(d) { return "Eller brug din " + d["0"] + "-konto"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b438488578 = messageFormatterFn((function(  ) {
  return function(d) { return "Optjen point til fremtidige rejser. Spar penge med medlemspriser. Få nem adgang til dine rejseplaner."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b450123496 = messageFormatterFn((function(  ) {
  return function(d) { return "Optjen " + d["0"] + " Expedia Rewards-point efter denne rejse"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1961810763 = messageFormatterFn((function(  ) {
  return function(d) { return "Log på " + d["0"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b268564365 = messageFormatterFn((function(  ) {
  return function(d) { return "Glemt adgangskode"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1217030692 = messageFormatterFn((function(  ) {
  return function(d) { return "Nulstil din adgangskode"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1436850942 = messageFormatterFn((function(  ) {
  return function(d) { return "Indtast din e-mailadresse, så sender vi dig et link til nulstilling af din adgangskode."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1518826710 = messageFormatterFn((function(  ) {
  return function(d) { return "Send link"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1203937415 = messageFormatterFn((function(  ) {
  return function(d) { return "Tjek din indbakke"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1459884577 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi har sendt en e-mail med et link til nulstilling af din adgangskode til " + d["0"] + "."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1459885538 = messageFormatterFn((function(  ) {
  return function(d) { return "Der kan gå et par minutter, før den når frem. Prøv at tjekke din spammappe, hvis du ikke modtager e-mailen inden for 10 minutter."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1061796596 = messageFormatterFn((function(  ) {
  return function(d) { return "Send linket igen"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1788190524 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi har sendt dig et nyt link."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b513621111 = messageFormatterFn((function(  ) {
  return function(d) { return "Verificerer konto..."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a221957705 = messageFormatterFn((function(  ) {
  return function(d) { return "Vælg adgangskode"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1413690226 = messageFormatterFn((function(  ) {
  return function(d) { return "Velkommen tilbage"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1319498328 = messageFormatterFn((function(  ) {
  return function(d) { return "Opret en unik adgangskode for at fortsætte"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1863046883 = messageFormatterFn((function(  ) {
  return function(d) { return "Sådan!"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1047800256 = messageFormatterFn((function(  ) {
  return function(d) { return "Anvend den nye adgangskode for at logge på."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b351800443 = messageFormatterFn((function(  ) {
  return function(d) { return "Nulstil adgangskode"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1666801576 = messageFormatterFn((function(  ) {
  return function(d) { return "Linket er desværre udløbet. Hvis du stadig har brug for at ændre din adgangskode, bedes du klikke nedenfor for at få tilsendt et nyt link."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b477357208 = messageFormatterFn((function(  ) {
  return function(d) { return "Send linket igen"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a2108228371 = messageFormatterFn((function(  ) {
  return function(d) { return "Gemmer din adgangskode..."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1045937319 = messageFormatterFn((function(  ) {
  return function(d) { return "Opret en konto"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1911710733 = messageFormatterFn((function(  ) {
  return function(d) { return "Opret en konto"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1321953896 = messageFormatterFn((function(  ) {
  return function(d) { return "E-mailadresse"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1890991120 = messageFormatterFn((function(  ) {
  return function(d) { return "Indtast din e-mailadresse."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b674571551 = messageFormatterFn((function(  ) {
  return function(d) { return "Indtast en gyldig e-mailadresse."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a224492215 = messageFormatterFn((function(  ) {
  return function(d) { return "Fornavn"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1312498991 = messageFormatterFn((function(  ) {
  return function(d) { return "Indtast dit fornavn."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b203664825 = messageFormatterFn((function(  ) {
  return function(d) { return "Efternavn"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b999851825 = messageFormatterFn((function(  ) {
  return function(d) { return "Indtast dit efternavn."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b413697848 = messageFormatterFn((function(  ) {
  return function(d) { return "Indtast navnet kun med bogstaver."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a646717633 = messageFormatterFn((function(  ) {
  return function(d) { return "Adgangskode"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b149469367 = messageFormatterFn((function(  ) {
  return function(d) { return "Indtast din adgangskode."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1883968808 = messageFormatterFn((function(  ) {
  return function(d) { return "Indtast en gyldig adgangskode."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1294999144 = messageFormatterFn((function(  ) {
  return function(d) { return "Skal bestå af 9-64 tegn"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1295000105 = messageFormatterFn((function(  ) {
  return function(d) { return "Skal indeholde både bogstaver og tal"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1295001066 = messageFormatterFn((function(  ) {
  return function(d) { return "Mindst ét specialtegn som ~ " + "#" + " @ $ % & ! * _ ? ^ - eller lignende"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1295002027 = messageFormatterFn((function(  ) {
  return function(d) { return "Din adgangskode må ikke indeholde mellemrum"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1951463410 = messageFormatterFn((function(  ) {
  return function(d) { return "Din adgangskode skal være mellem 8 og 64 tegn."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1797002053 = messageFormatterFn((function(  ) {
  return function(d) { return "Din adgangskode må ikke være den samme som din e-mailadresse."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1389911480 = messageFormatterFn((function(  ) {
  return function(d) { return "Din adgangskode må ikke indeholde mellemrum."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1057402896 = messageFormatterFn((function(  ) {
  return function(d) { return "Ved at oprette en konto accepterer jeg " + d["0"] + "s <a href=" + d["1"] + " " + d["3"] + ">vilkår og betingelser</a> samt <a href=" + d["2"] + " " + d["4"] + ">privatlivspolitik</a>."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1443568014 = messageFormatterFn((function(  ) {
  return function(d) { return "Ved at oprette en konto accepterer jeg " + d["0"] + "s <a href=" + d["1"] + " " + d["5"] + ">vilkår og betingelser</a>, <a href=" + d["2"] + " " + d["6"] + ">privatlivspolitik</a> samt <a href=" + d["3"] + " " + d["7"] + ">vilkår og betingelser for " + d["4"] + "</a>."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1708663021 = messageFormatterFn((function(  ) {
  return function(d) { return "Jeg vil gerne modtage rejsetilbud, særtilbud og andre oplysninger pr. e-mail fra " + d["0"] + "."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a902568508 = messageFormatterFn((function(  ) {
  return function(d) { return "Jeg vil gerne modtage rejsetilbud, særtilbud og andre oplysninger pr. e-mail fra " + d["0"] + ". Hvis du ikke længere ønsker at modtage kampagne-e-mails, kan du til hver en tid framelde dig disse."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1959475862 = messageFormatterFn((function(  ) {
  return function(d) { return "Jeg vil gerne modtage ferieinspiration, særtilbud og andre oplysninger pr. e-mail fra " + d["0"] + "."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1731382169 = messageFormatterFn((function(  ) {
  return function(d) { return "Jeg vil gerne modtage ferieinspiration, særtilbud og andre oplysninger pr. e-mail fra " + d["0"] + ". Hvis du ikke længere ønsker at modtage kampagne-e-mails, kan du til hver en tid framelde dig disse."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1848195379 = messageFormatterFn((function(  ) {
  return function(d) { return "Fortsæt"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b385863578 = messageFormatterFn((function(  ) {
  return function(d) { return "Har du allerede en konto? <span><a id=\"signinRedirectLink\" href=" + d["0"] + ">Log på</a></span>"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b33807785 = messageFormatterFn((function(  ) {
  return function(d) { return "Velkommen " + d["0"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b473441649 = messageFormatterFn((function(  ) {
  return function(d) { return "Med din nye " + d["0"] + "-konto er verden indenfor din rækkevidde."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b615369192 = messageFormatterFn((function(  ) {
  return function(d) { return "Fortsæt"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a420243257 = messageFormatterFn((function(  ) {
  return function(d) { return "Du skal oprette en stærkere adgangskode, før du kan fortsætte."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1550303234 = messageFormatterFn((function(  ) {
  return function(d) { return "Skal bestå af minimum 8 tegn."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a103261218 = messageFormatterFn((function(  ) {
  return function(d) { return "Adgangskodens styrke"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b786459168 = messageFormatterFn((function(  ) {
  return function(d) { return "Svag"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1628972545 = messageFormatterFn((function(  ) {
  return function(d) { return "Stærk"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1079883477 = messageFormatterFn((function(  ) {
  return function(d) { return "Meget stærk"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1863148496 = messageFormatterFn((function(  ) {
  return function(d) { return "Undgå forudsigelige bogstavserstatninger som f.eks. “@” i stedet for “a”."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b885702760 = messageFormatterFn((function(  ) {
  return function(d) { return "Undgå at stave almindelige ord bagfra."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1570978464 = messageFormatterFn((function(  ) {
  return function(d) { return "Skriv flere bogstaver med stort, men ikke alle bogstaver."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1742604415 = messageFormatterFn((function(  ) {
  return function(d) { return "Skriv flere bogstaver med stort, ikke kun det første bogstav."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a923568443 = messageFormatterFn((function(  ) {
  return function(d) { return "Undgå datoer og årstal, der har med dig at gøre."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1431720143 = messageFormatterFn((function(  ) {
  return function(d) { return "Undgå de seneste årstal."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1816333748 = messageFormatterFn((function(  ) {
  return function(d) { return "Undgå årstal, der har med dig at gøre."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1069248863 = messageFormatterFn((function(  ) {
  return function(d) { return "Undgå ofte brugte kombinationer af tegn."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a630430523 = messageFormatterFn((function(  ) {
  return function(d) { return "Undgå at gentage ord og tegn."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1572652449 = messageFormatterFn((function(  ) {
  return function(d) { return "Angiv en mere varieret adgangskode, og skift retning flere gange."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b970152508 = messageFormatterFn((function(  ) {
  return function(d) { return "Tilføj flere ord, som ikke bruges så ofte"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a360342832 = messageFormatterFn((function(  ) {
  return function(d) { return "Brug flere ord, men undgå ofte brugte vendinger."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1649043091 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kan oprette en stæk adgangskode uden brug af symboler, tal og store bogstaver."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1503795750 = messageFormatterFn((function(  ) {
  return function(d) { return "Denne e-mailadresse er allerede tilknyttet en konto hos " + d["0"] + "."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a590391092 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi har sendt dig et link via e-mail til at gennemføre oprettelsen af din konto."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1058410909 = messageFormatterFn((function(  ) {
  return function(d) { return "Opretter konto..."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1239178063 = messageFormatterFn((function(  ) {
  return function(d) { return "Fornavn skal bestå af mindst to bogstaver"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b118347329 = messageFormatterFn((function(  ) {
  return function(d) { return "Efternavn skal bestå af mindst to bogstaver"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1807739395 = messageFormatterFn((function(  ) {
  return function(d) { return "Fornavnet må ikke være længere end 100 tegn"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1129702509 = messageFormatterFn((function(  ) {
  return function(d) { return "Efternavnet må ikke være længere end 100 tegn"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1649061448 = messageFormatterFn((function(  ) {
  return function(d) { return "Fornavnet må ikke indeholde specialtegn"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b560905176 = messageFormatterFn((function(  ) {
  return function(d) { return "Efternavnet må ikke indeholde specialtegn"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1310539754 = messageFormatterFn((function(  ) {
  return function(d) { return "Jeg accepterer nedenstående"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1347714722 = messageFormatterFn((function(  ) {
  return function(d) { return "Jeg bekræfter, at jeg er fyldt 18 år, og at jeg har læst og accepterer de gældende <a href=" + d["0"] + " " + d["1"] + ">vilkår for brug</a> samt <a href=" + d["2"] + " " + d["3"] + ">vilkår og betingelser for " + d["4"] + "</a> (obligatorisk)"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a422635488 = messageFormatterFn((function(  ) {
  return function(d) { return "Jeg giver samtykke til indsamling og brug af mine personlige oplysninger i henhold til <a href=" + d["0"] + " " + d["1"] + ">privatlivspolitikken</a> (obligatorisk)"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b2009654291 = messageFormatterFn((function(  ) {
  return function(d) { return "Jeg giver samtykke til udlevering af mine personlige oplysninger til tredjeparter enten i Korea eller et andet land i henhold til <a href=" + d["0"] + " " + d["1"] + ">privatlivspolitikken</a> (obligatorisk)"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1568644650 = messageFormatterFn((function(  ) {
  return function(d) { return "Du skal acceptere betingelserne for at fortsætte."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1376742362 = messageFormatterFn((function(  ) {
  return function(d) { return "Du skal acceptere betingelserne for at fortsætte."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1085691810 = messageFormatterFn((function(  ) {
  return function(d) { return "Markér afkrydsningsfeltet for at fortsætte."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1065014373 = messageFormatterFn((function(  ) {
  return function(d) { return "Eller opret en konto med " + d["0"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a426919491 = messageFormatterFn((function(  ) {
  return function(d) { return "Undgå at anvende mellemrum, dit navn, din e-mailadresse eller adgangskoder, du tidligere har anvendt."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b115763847 = messageFormatterFn((function(  ) {
  return function(d) { return "Der er desværre opstået en fejl. Vent et øjeblik, og prøv igen."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1517536159 = messageFormatterFn((function(  ) {
  return function(d) { return "Bekræft dit mobilnummer"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1230388016 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi sender en verificeringskode til dit mobilnummer for at holde din konto sikker."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1096820503 = messageFormatterFn((function(  ) {
  return function(d) { return "Send"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a2012494352 = messageFormatterFn((function(  ) {
  return function(d) { return "© " + d["1"] + " " + d["0"] + " Alle rettigheder forbeholdes."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a533112158 = messageFormatterFn((function(  ) {
  return function(d) { return "Vilkår og betingelser"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1886661663 = messageFormatterFn((function(  ) {
  return function(d) { return "Fortrolighedspolitik"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1130752758 = messageFormatterFn((function(  ) {
  return function(d) { return "Send mig en SMS"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1577103691 = messageFormatterFn((function(  ) {
  return function(d) { return "Indtast verificeringskode"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a831094397 = messageFormatterFn((function(  ) {
  return function(d) { return "Verificeringskode"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a356876528 = messageFormatterFn((function(  ) {
  return function(d) { return "Gensend kode"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b255116773 = messageFormatterFn((function(  ) {
  return function(d) { return "Ændr mobilnummer"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b891040519 = messageFormatterFn((function(  ) {
  return function(d) { return "Verificeringskoden er blevet sendt igen."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a387347310 = messageFormatterFn((function(  ) {
  return function(d) { return "Indtast den sekscifrede verificeringskode, vi lige har sendt til " + d["0"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b821774433 = messageFormatterFn((function(  ) {
  return function(d) { return "Kontrollerer verificeringskode"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a155374152 = messageFormatterFn((function(  ) {
  return function(d) { return "Koden er ikke korrekt. Gensend kode for at prøve igen."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1741316862 = messageFormatterFn((function(  ) {
  return function(d) { return "Eller fortsæt med"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a985104654 = messageFormatterFn((function(  ) {
  return function(d) { return "Få i gennemsnit " + d["0"] + "% rabat på tusindvis af hoteller som medlem – det er altid gratis."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b741398372 = messageFormatterFn((function(  ) {
  return function(d) { return "eller"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a114949018 = messageFormatterFn((function(  ) {
  return function(d) { return "Andre måder at logge på"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a115308432 = messageFormatterFn((function(  ) {
  return function(d) { return "Andre måder at tilmelde sig på"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a863878714 = messageFormatterFn((function(  ) {
  return function(d) { return "Tilmeld dig med Google"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b441353959 = messageFormatterFn((function(  ) {
  return function(d) { return "Det er desværre ikke muligt at logge dig på. Prøv igen, eller opret en konto på denne side for at fortsætte."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1914801005 = messageFormatterFn((function(  ) {
  return function(d) { return "Det er ikke muligt at logge på via telefonnummeret. Sørg for, at din konto på det sociale medie er indstillet til at dele din e-mail."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1256273013 = messageFormatterFn((function(  ) {
  return function(d) { return "Få mindst " + d["0"] + "% rabat på tusindvis af hoteller som medlem – det er altid gratis."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1469867408 = messageFormatterFn((function(  ) {
  return function(d) { return "Log på med Google"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1856372197 = messageFormatterFn((function(  ) {
  return function(d) { return "Log på med NAVER"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1548589967 = messageFormatterFn((function(  ) {
  return function(d) { return "Du har overskredet det maksimale antal loginforsøg. Prøv igen senere."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a450591202 = messageFormatterFn((function(  ) {
  return function(d) { return "Log på med biometrisk login"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a521081086 = messageFormatterFn((function(  ) {
  return function(d) { return "Brug biometrisk login til at få adgang til din konto, så du ikke behøver indtaste din adgangskode."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1688631061 = messageFormatterFn((function(  ) {
  return function(d) { return "Kom i gang"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1657777051 = messageFormatterFn((function(  ) {
  return function(d) { return "Påmind mig senere"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a662293893 = messageFormatterFn((function(  ) {
  return function(d) { return "Sådan!"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1588822699 = messageFormatterFn((function(  ) {
  return function(d) { return "Biometrisk login er blevet aktiveret."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a703034045 = messageFormatterFn((function(  ) {
  return function(d) { return "Log på med biometrisk login"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1535447618 = messageFormatterFn((function(  ) {
  return function(d) { return "Brug adgangskode"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b99089453 = messageFormatterFn((function(  ) {
  return function(d) { return "Brug biometrisk login"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a377211028 = messageFormatterFn((function(  ) {
  return function(d) { return "Opdater din adgangskode for at fortsætte"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1385117848 = messageFormatterFn((function(  ) {
  return function(d) { return "Adgangskoden skal nulstilles, før du kan få adgang til din konto."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1887244322 = messageFormatterFn((function(  ) {
  return function(d) { return "Nulstil adgangskode"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b38857314 = messageFormatterFn((function(  ) {
  return function(d) { return "Velkommen til medlemsfordele"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1571910076 = messageFormatterFn((function(  ) {
  return function(d) { return "Begynd dit næste eventyr med en gave fra os i form af point til en værdi af $" + d["0"] + "!"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1061338260 = messageFormatterFn((function(  ) {
  return function(d) { return "De er allerede tilgængelige på din konto og kan bruges på din første reservation – du skal bare anvende dine point på betalingssiden."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b496505062 = messageFormatterFn((function(  ) {
  return function(d) { return "Du er nu medlem af Expedia."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b2083521194 = messageFormatterFn((function(  ) {
  return function(d) { return "Begynd at spare penge med medlemspriser, og optjen point, når du booker."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a189949003 = messageFormatterFn((function(  ) {
  return function(d) { return "Log på, eller opret en konto"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a552283823 = messageFormatterFn((function(  ) {
  return function(d) { return "Få i gennemsnit " + d["0"] + "% rabat på tusindvis af hoteller som medlem – det er altid gratis."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1462728883 = messageFormatterFn((function(  ) {
  return function(d) { return "Ved at fortsætte bekræfter du, at du har læst og accepterer vores <a href=" + d["1"] + " " + d["3"] + ">vilkår og betingelser</a> og <a href=" + d["2"] + " " + d["4"] + ">privatlivspolitik</a>."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a250630799 = messageFormatterFn((function(  ) {
  return function(d) { return "Ved at fortsætte bekræfter du, at du har læst og accepterer vores <a href=" + d["1"] + " " + d["5"] + ">vilkår og betingelser</a>, <a href=" + d["2"] + " " + d["6"] + ">privatlivspolitik</a> og <a href=" + d["3"] + " " + d["7"] + ">vilkår og betingelser for " + d["4"] + "</a>."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b472860822 = messageFormatterFn((function(  ) {
  return function(d) { return "Ved at fortsætte bekræfter du, at du har læst og accepterer vores <a href=" + d["1"] + " " + d["4"] + ">vilkår og betingelser</a>, <a href=" + d["2"] + " " + d["5"] + ">privatlivspolitik</a> samt <a href=" + d["3"] + " " + d["6"] + ">vilkår og betingelser for loyalitetsprogrammet One Key</a>."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1002104506 = messageFormatterFn((function(  ) {
  return function(d) { return "E-mailadresse"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1248561036 = messageFormatterFn((function(  ) {
  return function(d) { return "Indtast en gyldig e-mailadresse"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1406904055 = messageFormatterFn((function(  ) {
  return function(d) { return "Google"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1657495428 = messageFormatterFn((function(  ) {
  return function(d) { return "Facebook"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1786261902 = messageFormatterFn((function(  ) {
  return function(d) { return "Apple"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1446428405 = messageFormatterFn((function(  ) {
  return function(d) { return "Dette er kun til personlige enheder. Undlad at markere dette felt på delte enheder for at holde din konto sikker."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1822523652 = messageFormatterFn((function(  ) {
  return function(d) { return "Du har forsøgt at logge på for mange gange. Du er nødt til at vente " + d["0"] + " minutter, før du kan prøve igen."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1613682336 = messageFormatterFn((function(  ) {
  return function(d) { return "Du har forsøgt at logge på for mange gange. Du er nødt til at vente " + d["0"] + " minut, før du kan prøve igen."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1608787002 = messageFormatterFn((function(  ) {
  return function(d) { return "Du har forsøgt at logge på for mange gange. Du er nødt til at vente " + d["0"] + " minutter, før du kan prøve igen."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1622244846 = messageFormatterFn((function(  ) {
  return function(d) { return "Du har forsøgt at logge på for mange gange. Du er nødt til at vente " + d["0"] + " minutter, før du kan prøve igen."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1446541051 = messageFormatterFn((function(  ) {
  return function(d) { return "Du har forsøgt at logge på for mange gange. Du er nødt til at vente " + d["0"] + " minutter, før du kan prøve igen."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b88968246 = messageFormatterFn((function(  ) {
  return function(d) { return "Du har forsøgt at logge på for mange gange. Du er nødt til at vente " + d["0"] + " minutter, før du kan prøve igen."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a259025721 = messageFormatterFn((function(  ) {
  return function(d) { return "Få adgang til en verden af fordele med én konto på tværs af Expedia, Hotels.com og Vrbo."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1824904481 = messageFormatterFn((function(  ) {
  return function(d) { return "Få adgang til en verden af rejser med én konto på tværs af Expedia, Hotels.com og Vrbo."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a747730534 = messageFormatterFn((function(  ) {
  return function(d) { return "Søg efter og gem overnatningssteder, planlæg rejser med din gruppe, og få adgang til dine reservationsoplysninger."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a142770533 = messageFormatterFn((function(  ) {
  return function(d) { return "Din konto blev sat på pause i forbindelse med et rutinemæssigt sikkerhedstjek. Dine oplysninger er sikre, men du skal nulstille din adgangskode."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1275785835 = messageFormatterFn((function(  ) {
  return function(d) { return "Log på, og book dit ophold for at optjene OneKeyCash"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b753878455 = messageFormatterFn((function(  ) {
  return function(d) { return "Lad os bekræfte din identitet"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a2139369457 = messageFormatterFn((function(  ) {
  return function(d) { return "Indtast den sikkerhedskode, vi har sendt til din e-mail. Kig i din mappe med uønskede e-mails, hvis du ikke kan finde e-mailen i din indbakke."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1966289957 = messageFormatterFn((function(  ) {
  return function(d) { return "Bekræft din e-mailadresse"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b431694561 = messageFormatterFn((function(  ) {
  return function(d) { return "Indtast den sikkerhedskode, vi har sendt til " + d["0"] + " for at fortsætte. Kig i din mappe med uønskede e-mails, hvis du ikke kan finde e-mailen i din indbakke."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1874303623 = messageFormatterFn((function(  ) {
  return function(d) { return "Kode med 6 cifre"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1224967815 = messageFormatterFn((function(  ) {
  return function(d) { return "Gensend kode"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b70637666 = messageFormatterFn((function(  ) {
  return function(d) { return "(0:" + d["0"] + ")"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1670451962 = messageFormatterFn((function(  ) {
  return function(d) { return "Gensend kode om " + d["0"] + " sek."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1816639286 = messageFormatterFn((function(  ) {
  return function(d) { return "Har du ikke modtaget en e-mail?"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a289499944 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kan anmode om en ny kode om " + d["0"] + " sek."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a39995137 = messageFormatterFn((function(  ) {
  return function(d) { return "Anmod om en ny kode "; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a531478347 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi har sendt en ny kode til din indbakke."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b444138794 = messageFormatterFn((function(  ) {
  return function(d) { return "Indtast adgangskode i stedet"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1821584299 = messageFormatterFn((function(  ) {
  return function(d) { return "Ugyldig kode. Prøv igen."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a713085657 = messageFormatterFn((function(  ) {
  return function(d) { return "Koden er udløbet. Gensend, og prøv igen."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1898304690 = messageFormatterFn((function(  ) {
  return function(d) { return "Kig i din mappe med uønskede e-mails, hvis du ikke kan finde e-mailen i din indbakke."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1354969291 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi har foretaget opdateringer og er nødt til at bekræfte din e-mailadresse. Indtast den sikkerhedskode, vi har sendt til din indbakke."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1068890026 = messageFormatterFn((function(  ) {
  return function(d) { return "Der opstod desværre en fejl. Prøv igen."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a606610035 = messageFormatterFn((function(  ) {
  return function(d) { return "Indtast den sikkerhedskode, vi har sendt til din e-mail for at opdatere din loginmetode."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b435570893 = messageFormatterFn((function(  ) {
  return function(d) { return "Indtast din adgangskode"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b598263188 = messageFormatterFn((function(  ) {
  return function(d) { return "Send en sikker kode via e-mail"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a2116164212 = messageFormatterFn((function(  ) {
  return function(d) { return "E-mailadressen og adgangskoden stemmer ikke overens"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a2041374525 = messageFormatterFn((function(  ) {
  return function(d) { return "Opret en adgangskode"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a888409575 = messageFormatterFn((function(  ) {
  return function(d) { return "Opret en adgangskode"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b725364845 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kan bruge samme e-mailadresse og adgangskode til at logge på Expedia, Hotels.com og Vrbo."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1180213075 = messageFormatterFn((function(  ) {
  return function(d) { return "Opret adgangskode"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1979525744 = messageFormatterFn((function(  ) {
  return function(d) { return "Opret en adgangskode, der kan bruges i tillæg til andre sikre loginmetoder."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1284175813 = messageFormatterFn((function(  ) {
  return function(d) { return "Opret en ny adgangskode"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b930079633 = messageFormatterFn((function(  ) {
  return function(d) { return "Opret en ny adgangskode"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1380111371 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kan nu bruge én konto til at logge på Expedia, Hotels.com og Vrbo. Opret en ny, sikker adgangskode til din konto."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b640653003 = messageFormatterFn((function(  ) {
  return function(d) { return "Opret adgangskode"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b281954157 = messageFormatterFn((function(  ) {
  return function(d) { return "Ændr adgangskode"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1767531517 = messageFormatterFn((function(  ) {
  return function(d) { return "Brug en unik og stærk adgangskode."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a415792131 = messageFormatterFn((function(  ) {
  return function(d) { return "Opdater adgangskode"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a661572336 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi kunne ikke ændre din adgangskode. Prøv igen."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a52693774 = messageFormatterFn((function(  ) {
  return function(d) { return "Glemt adgangskode"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a390622476 = messageFormatterFn((function(  ) {
  return function(d) { return "Indtast din e-mailadresse, så sender vi dig en kode, du kan bruge til at logge på."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b2143771500 = messageFormatterFn((function(  ) {
  return function(d) { return "Send e-mail"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1717185248 = messageFormatterFn((function(  ) {
  return function(d) { return "Kontakt os"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b2023829489 = messageFormatterFn((function(  ) {
  return function(d) { return "Slet konto"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b350881148 = messageFormatterFn((function(  ) {
  return function(d) { return "Luk"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1274573400 = messageFormatterFn((function(  ) {
  return function(d) { return "Vent venligst, mens vi tjekker din konto."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a746050711 = messageFormatterFn((function(  ) {
  return function(d) { return "Slet konto"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1699312645 = messageFormatterFn((function(  ) {
  return function(d) { return "OK"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b219416855 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kan ikke slette din konto, før din rejse er gennemført."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1323947850 = messageFormatterFn((function(  ) {
  return function(d) { return "Du har brug for din konto for at få adgang til din reservation og få hjælp af vores team i tilfælde af ændringer eller afbestillinger i sidste øjeblik."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b947621495 = messageFormatterFn((function(  ) {
  return function(d) { return "Du skal først slette din udlejer-konto på Vrbo"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b256535410 = messageFormatterFn((function(  ) {
  return function(d) { return "Gå til vores hjælpecenter på hjemmesiden eller i appen, eller kontakt kundeservice direkte for at begynde sletningen."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a314954174 = messageFormatterFn((function(  ) {
  return function(d) { return "Prøv igen, når din rejse er gennemført."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b541657637 = messageFormatterFn((function(  ) {
  return function(d) { return "Hvorfor vil du slette din konto?"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a283924820 = messageFormatterFn((function(  ) {
  return function(d) { return "Jeg får for mange e-mails eller notifikationer"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b283537174 = messageFormatterFn((function(  ) {
  return function(d) { return "Jeg har en anden " + d["0"] + " konto"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1015843163 = messageFormatterFn((function(  ) {
  return function(d) { return "Min rejse er gennemført, så jeg har ikke længere brug for denne konto"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1424813909 = messageFormatterFn((function(  ) {
  return function(d) { return "Jeg har haft en negativ reservationsoplevelse med " + d["0"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b844218796 = messageFormatterFn((function(  ) {
  return function(d) { return "Andet"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a781481961 = messageFormatterFn((function(  ) {
  return function(d) { return "Spring over"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1615553072 = messageFormatterFn((function(  ) {
  return function(d) { return "Indsend"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1639971904 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi er kede af, at du forlader os. Her er nogle vigtige oplysninger:"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b555269811 = messageFormatterFn((function(  ) {
  return function(d) { return "Du mister " + d["0"] + " Expedia Rewards-point til en værdi af " + d["1"] + ", tilgodehavender til en værdi af " + d["2"] + ", dine kontopræferencer samt eventuelle kuponer og gemte rejser."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1403385284 = messageFormatterFn((function(  ) {
  return function(d) { return "Du mister " + d["0"] + " Expedia Rewards-point til en værdi af " + d["1"] + ", dine kontopræferencer samt eventuelle kuponer og gemte rejser."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1486744262 = messageFormatterFn((function(  ) {
  return function(d) { return "Du mister dine ferietavler, tilgodehavende og præferencer."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a2048357884 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels.com Rewards: Du mister " + d["0"] + " bonusnat/bonusnætter til en værdi af " + d["1"] + " og " + d["2"] + " stempler til en gennemsnitlig værdi af " + d["3"] + "."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1894420621 = messageFormatterFn((function(  ) {
  return function(d) { return "Du mister dine tilgodehavender, kontopræferencer samt eventuelle kuponer og gemte rejser."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a289912885 = messageFormatterFn((function(  ) {
  return function(d) { return "Du mister " + d["0"] + " CheapCash til en værdi af " + d["1"] + ", tilgodehavender til en værdi af " + d["2"] + ", dine kontopræferencer samt eventuelle kuponer og gemte rejser."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1065509412 = messageFormatterFn((function(  ) {
  return function(d) { return "Du mister " + d["0"] + " CheapCash til en værdi af " + d["1"] + ", dine kontopræferencer samt eventuelle kuponer og gemte rejser."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b780713491 = messageFormatterFn((function(  ) {
  return function(d) { return "Du mister " + d["0"] + " Orbucks til en værdi af " + d["1"] + ", tilgodehavender til en værdi af " + d["2"] + ", dine kontopræferencer samt eventuelle kuponer og gemte rejser."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b165850844 = messageFormatterFn((function(  ) {
  return function(d) { return "Du mister " + d["0"] + " Orbucks til en værdi af " + d["1"] + ", dine kontopræferencer samt eventuelle kuponer og gemte rejser."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b545999347 = messageFormatterFn((function(  ) {
  return function(d) { return "Du mister " + d["0"] + " MrJet Rewards til en værdi af " + d["1"] + ", tilgodehavender til en værdi af " + d["2"] + ", dine kontopræferencer samt eventuelle kuponer og gemte rejser."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1390147324 = messageFormatterFn((function(  ) {
  return function(d) { return "Du mister " + d["0"] + " MrJet Rewards til en værdi af " + d["1"] + ", dine kontopræferencer samt eventuelle kuponer og gemte rejser."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b184618027 = messageFormatterFn((function(  ) {
  return function(d) { return "Du mister " + d["0"] + " BONUS+ til en værdi af " + d["1"] + ", tilgodehavender til en værdi af " + d["2"] + ", dine kontopræferencer samt eventuelle kuponer og gemte rejser."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b192225732 = messageFormatterFn((function(  ) {
  return function(d) { return "Du mister " + d["0"] + " BONUS+ til en værdi af " + d["1"] + ", dine kontopræferencer samt eventuelle kuponer og gemte rejser."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1863504479 = messageFormatterFn((function(  ) {
  return function(d) { return "Du mister dine kontopræferencer samt eventuelle kuponer og gemte rejser."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1745601972 = messageFormatterFn((function(  ) {
  return function(d) { return "Du mister tilgodehavender til en værdi af " + d["0"] + ", dine kontopræferencer samt eventuelle kuponer og gemte rejser."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b330540542 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi beholder muligvis nogle af dine oplysninger, såsom transaktionshistorik, grundet juridiske forpligtelser eller hvis vi skal etablere, udøve eller forsvare et retskrav. Disse oplysninger opbevares sikkert og vil blive slettet, anonymiseret eller permanent tilsløret, når de ikke længere er påkrævet ved lov."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1895725354 = messageFormatterFn((function(  ) {
  return function(d) { return "Slet kontoen permanent"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a2010545478 = messageFormatterFn((function(  ) {
  return function(d) { return "Slet ikke kontoen"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b772588356 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi håber, at vi ses igen"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1992887203 = messageFormatterFn((function(  ) {
  return function(d) { return "Det kan tage nogle uger at behandle anmodningen om sletning, så det er muligt, at du forsat modtager kommunikation fra os, indtil systemet er opdateret."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b865629769 = messageFormatterFn((function(  ) {
  return function(d) { return "Prøv igen"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1873293130 = messageFormatterFn((function(  ) {
  return function(d) { return "Der opstod en systemfejl. Prøv at slette din konto igen, eller prøv igen om et par minutter."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1513088018 = messageFormatterFn((function(  ) {
  return function(d) { return "Luk"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b544358293 = messageFormatterFn((function(  ) {
  return function(d) { return "Hvilket navn står i dit rejsedokument?"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b173816187 = messageFormatterFn((function(  ) {
  return function(d) { return "Sørg for, at navnet på din konto svarer til det navn, der står i dit pas eller andet rejsedokument. Så har vi det klar, næste gang du booker."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a2119042419 = messageFormatterFn((function(  ) {
  return function(d) { return "Få tilbud og andre oplysninger fra " + d["0"] + " via e-mail."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1585401820 = messageFormatterFn((function(  ) {
  return function(d) { return "Få tilbud og andre oplysninger fra " + d["0"] + " via e-mail. Du kan fravælge markedsførings-e-mails når som helst."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1282169961 = messageFormatterFn((function(  ) {
  return function(d) { return "Kontooplysninger"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1676766931 = messageFormatterFn((function(  ) {
  return function(d) { return "Få e-mails om tilbud og andre oplysninger fra " + d["0"] + ". Du kan fravælge e-mails når som helst."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a494429001 = messageFormatterFn((function(  ) {
  return function(d) { return "Hold dig opdateret"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1551209475 = messageFormatterFn((function(  ) {
  return function(d) { return "Samtykke til markedsføring"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1567200524 = messageFormatterFn((function(  ) {
  return function(d) { return "Expedia Rewards"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1009705942 = messageFormatterFn((function(  ) {
  return function(d) { return "CheapCash"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b712246706 = messageFormatterFn((function(  ) {
  return function(d) { return "Orbitz Rewards"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1187452918 = messageFormatterFn((function(  ) {
  return function(d) { return "BONUS+"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a564587916 = messageFormatterFn((function(  ) {
  return function(d) { return "MrJet"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a2116824669 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels.com Rewards"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1978417551 = messageFormatterFn((function(  ) {
  return function(d) { return "One Key"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1856292292 = messageFormatterFn((function(  ) {
  return function(d) { return "Du er nødt til at vente, til din rejse er gennemført"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b821816300 = messageFormatterFn((function(  ) {
  return function(d) { return "Du er nødt til at vente, til dine kommende rejser er gennemført"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a494760614 = messageFormatterFn((function(  ) {
  return function(d) { return "Din konto giver dig adgang til dine reservationsoplysninger og support, hvis du skulle få brug for det. Prøv igen, når din rejse er gennemført."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1806223746 = messageFormatterFn((function(  ) {
  return function(d) { return "Din konto giver dig adgang til dine reservationsoplysninger og support, hvis du skulle få brug for det. Prøv igen, når dine rejser er gennemført."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1999359241 = messageFormatterFn((function(  ) {
  return function(d) { return "Din konto kan desværre ikke slettes på nuværende tidspunkt"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1369655455 = messageFormatterFn((function(  ) {
  return function(d) { return "Denne konto bruges også til at udleje overnatningssteder på Vrbo. Du skal logge på din konto i Vrbo's app til udlejere eller på hjemmesiden og fjerne dine aktive overnatningssteder, før du kan slette din konto."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1357661266 = messageFormatterFn((function(  ) {
  return function(d) { return "Fortæl os, hvorfor du vil slette din konto:"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1403809923 = messageFormatterFn((function(  ) {
  return function(d) { return "Jeg har en konto med en anden e-mailadresse"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b494634370 = messageFormatterFn((function(  ) {
  return function(d) { return "Jeg har haft en negativ reservationsoplevelse"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a177578579 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi er kede af, du ikke længere ønsker at have en konto hos os. Bemærk, at sletning af din konto ikke kan fortrydes. Det påvirker også dine data hos Expedia, Hotels.com og Vrbo. Her er nogle vigtige oplysninger:"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b521713442 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi er kede af, at du ikke længere ønsker at have en konto hos os. Bemærk, at sletning af din konto ikke kan fortrydes. Det påvirker også dine data hos Expedia, Wotif, Hotels.com og Vrbo. Her er nogle vigtige oplysninger:"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a829021961 = messageFormatterFn((function(  ) {
  return function(d) { return "Du mister din kontohistorik, dine kontopræferencer og dine gemte rejser på tværs af Expedia, Hotels.com og Vrbo."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a709666068 = messageFormatterFn((function(  ) {
  return function(d) { return "Du mister din kontohistorik, dine kontopræferencer og dine gemte rejser på tværs af Expedia, Wotif, Hotels.com og Vrbo."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1711169667 = messageFormatterFn((function(  ) {
  return function(d) { return "Du mister alle dine OneKeyCash, herunder afventende OneKeyCash, og dit medlemsniveau i One Key inklusive alle fordele."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1194913293 = messageFormatterFn((function(  ) {
  return function(d) { return "Du mister alle afventende OneKeyCash og dit medlemsniveau i One Key inklusive alle fordele."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b883839400 = messageFormatterFn((function(  ) {
  return function(d) { return "Du mister " + d["0"] + " i OneKeyCash, alle afventende OneKeyCash og dit medlemsniveau i One Key inklusive alle fordele."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b230278018 = messageFormatterFn((function(  ) {
  return function(d) { return "Indehavere af Hotels.com Rewards Credit Card modtager ikke længere fordele baseret på kortaktivitet."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1066972635 = messageFormatterFn((function(  ) {
  return function(d) { return "Du mister alle dine Expedia Rewards-point, herunder bekræftede og afventende point, stempler og bonusnætter hos Hotels.com Rewards samt dit medlemsniveau."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1059848879 = messageFormatterFn((function(  ) {
  return function(d) { return "Du mister alle afventende Expedia Rewards-point, stempler og bonusnætter hos Hotels.com Rewards samt dit medlemsniveau."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a932181975 = messageFormatterFn((function(  ) {
  return function(d) { return "Du mister alle dine kuponer og tilgodehavender hos Expedia, Hotels.com og Vrbo."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1564185758 = messageFormatterFn((function(  ) {
  return function(d) { return "Du mister alle dine kuponer og tilgodehavender hos Expedia, Wotif, Hotels.com og Vrbo."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1225216176 = messageFormatterFn((function(  ) {
  return function(d) { return "Det kan tage nogle uger at behandle anmodningen om sletning af din konto hos Expedia, Hotels.com og Vrbo, så det er muligt, at du fortsat modtager kommunikation fra os, indtil systemet er blevet opdateret."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a2055339387 = messageFormatterFn((function(  ) {
  return function(d) { return "Det kan tage nogle uger at behandle anmodningen om sletning af din konto hos Expedia, Wotif, Hotels.com og Vrbo, så det er muligt, at du fortsat modtager kommunikation fra os, indtil systemet er blevet opdateret."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b768019803 = messageFormatterFn((function(  ) {
  return function(d) { return "Dit One Key Card bliver lukket, når du sletter din konto, og du kan ikke længere optjene OneKeyCash på køb. Wells Fargo kontakter dig for at bekræfte lukningen af dit kort."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1310754651 = messageFormatterFn((function(  ) {
  return function(d) { return "Dit One Key+ Card bliver lukket, når du sletter din konto, og du kan ikke længere optjene OneKeyCash på køb. Wells Fargo kontakter dig for at bekræfte lukningen af dit kort."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1952799834 = messageFormatterFn((function(  ) {
  return function(d) { return "Log på eller opret en konto for at optjene OneKeyCash for din rejse"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a354238196 = messageFormatterFn((function(  ) {
  return function(d) { return "Log på eller opret en konto for at optjene fordele for dit ophold"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1669259099 = messageFormatterFn((function(  ) {
  return function(d) { return "Betal som gæst"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1762325129 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "-login: Tilføj mobilnummer"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b849559673 = messageFormatterFn((function(  ) {
  return function(d) { return "Der opstod en fejl"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1612976289 = messageFormatterFn((function(  ) {
  return function(d) { return "Prøv at logge på igen"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a368143702 = messageFormatterFn((function(  ) {
  return function(d) { return "OK"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1389414050 = dateToPartsFormatterFn({"2":Globalize("da-DK").numberFormatter({"raw":"00"}),"4":Globalize("da-DK").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy-MM-dd","timeSeparator":"."});
Globalize.a274867682 = dateToPartsFormatterFn({"2":Globalize("da-DK").numberFormatter({"raw":"00"}),"4":Globalize("da-DK").numberFormatter({"raw":"0000"})}, {"pattern":"dd/MM/yyyy","timeSeparator":"."});
Globalize.a1000153781 = dateToPartsFormatterFn({"1":Globalize("da-DK").numberFormatter({"raw":"0"}),"4":Globalize("da-DK").numberFormatter({"raw":"0000"})}, {"pattern":"d/M/yyyy","timeSeparator":"."});
Globalize.b122300177 = dateToPartsFormatterFn({"1":Globalize("da-DK").numberFormatter({"raw":"0"}),"4":Globalize("da-DK").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/M/d","timeSeparator":"."});
Globalize.a329008706 = dateToPartsFormatterFn({"2":Globalize("da-DK").numberFormatter({"raw":"00"}),"4":Globalize("da-DK").numberFormatter({"raw":"0000"})}, {"pattern":"dd.MM.yyyy","timeSeparator":"."});
Globalize.b546143049 = dateToPartsFormatterFn({"1":Globalize("da-DK").numberFormatter({"raw":"0"}),"4":Globalize("da-DK").numberFormatter({"raw":"0000"})}, {"pattern":"d.M.yyyy","timeSeparator":"."});
Globalize.a2126730722 = dateToPartsFormatterFn({"2":Globalize("da-DK").numberFormatter({"raw":"00"}),"4":Globalize("da-DK").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/MM/dd","timeSeparator":"."});
Globalize.a383149730 = dateToPartsFormatterFn({"2":Globalize("da-DK").numberFormatter({"raw":"00"}),"4":Globalize("da-DK").numberFormatter({"raw":"0000"})}, {"pattern":"dd-MM-yyyy","timeSeparator":"."});
Globalize.a912644002 = dateToPartsFormatterFn({"2":Globalize("da-DK").numberFormatter({"raw":"00"}),"4":Globalize("da-DK").numberFormatter({"raw":"0000"})}, {"pattern":"MM/dd/yyyy","timeSeparator":"."});
Globalize.a758582389 = dateToPartsFormatterFn({"1":Globalize("da-DK").numberFormatter({"raw":"0"}),"4":Globalize("da-DK").numberFormatter({"raw":"0000"})}, {"pattern":"M/d/yyyy","timeSeparator":"."});
Globalize.b389411262 = dateToPartsFormatterFn({"2":Globalize("da-DK").numberFormatter({"raw":"00"}),"4":Globalize("da-DK").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy.MM.dd","timeSeparator":"."});
Globalize.a1294093437 = dateToPartsFormatterFn({}, {"pattern":"EEEEE","timeSeparator":".","days":{"E":{"5":{"sun":"S","mon":"M","tue":"T","wed":"O","thu":"T","fri":"F","sat":"L"}}}});
Globalize.a1565734754 = dateToPartsFormatterFn({}, {"pattern":"EEEE","timeSeparator":".","days":{"E":{"4":{"sun":"søndag","mon":"mandag","tue":"tirsdag","wed":"onsdag","thu":"torsdag","fri":"fredag","sat":"lørdag"}}}});
Globalize.a312489314 = dateToPartsFormatterFn({}, {"pattern":"MMMM","timeSeparator":".","months":{"M":{"4":{"1":"januar","2":"februar","3":"marts","4":"april","5":"maj","6":"juni","7":"juli","8":"august","9":"september","10":"oktober","11":"november","12":"december"}}}});
Globalize.a1588976318 = dateToPartsFormatterFn({"1":Globalize("da-DK").numberFormatter({"raw":"0"})}, {"pattern":"d","timeSeparator":"."});
Globalize.a1363832917 = dateToPartsFormatterFn({"1":Globalize("da-DK").numberFormatter({"raw":"0"}),"2":Globalize("da-DK").numberFormatter({"raw":"00"})}, {"pattern":"M/d/yy","timeSeparator":"."});
Globalize.a866626124 = dateToPartsFormatterFn({"1":Globalize("da-DK").numberFormatter({"raw":"0"})}, {"pattern":"d. MMM","timeSeparator":".","months":{"M":{"3":{"1":"jan.","2":"feb.","3":"mar.","4":"apr.","5":"maj","6":"jun.","7":"jul.","8":"aug.","9":"sep.","10":"okt.","11":"nov.","12":"dec."}}}});
Globalize.a1076244925 = dateToPartsFormatterFn({"1":Globalize("da-DK").numberFormatter({"raw":"0"})}, {"pattern":"d. MMMM","timeSeparator":".","months":{"M":{"4":{"1":"januar","2":"februar","3":"marts","4":"april","5":"maj","6":"juni","7":"juli","8":"august","9":"september","10":"oktober","11":"november","12":"december"}}}});
Globalize.a1060875416 = dateToPartsFormatterFn({"1":Globalize("da-DK").numberFormatter({"raw":"0"})}, {"pattern":"d. MMMM y","timeSeparator":".","months":{"M":{"4":{"1":"januar","2":"februar","3":"marts","4":"april","5":"maj","6":"juni","7":"juli","8":"august","9":"september","10":"oktober","11":"november","12":"december"}}}});
Globalize.a449803144 = dateToPartsFormatterFn({"1":Globalize("da-DK").numberFormatter({"raw":"0"})}, {"pattern":"MMMM y","timeSeparator":".","months":{"M":{"4":{"1":"januar","2":"februar","3":"marts","4":"april","5":"maj","6":"juni","7":"juli","8":"august","9":"september","10":"oktober","11":"november","12":"december"}}}});
Globalize.a450488337 = dateToPartsFormatterFn({"1":Globalize("da-DK").numberFormatter({"raw":"0"})}, {"pattern":"d. MMM y","timeSeparator":".","months":{"M":{"3":{"1":"jan.","2":"feb.","3":"mar.","4":"apr.","5":"maj","6":"jun.","7":"jul.","8":"aug.","9":"sep.","10":"okt.","11":"nov.","12":"dec."}}}});
Globalize.b1368146804 = dateToPartsFormatterFn({"1":Globalize("da-DK").numberFormatter({"raw":"0"})}, {"pattern":"EEEE d. MMM","timeSeparator":".","days":{"E":{"4":{"sun":"søndag","mon":"mandag","tue":"tirsdag","wed":"onsdag","thu":"torsdag","fri":"fredag","sat":"lørdag"}}},"months":{"M":{"3":{"1":"jan.","2":"feb.","3":"mar.","4":"apr.","5":"maj","6":"jun.","7":"jul.","8":"aug.","9":"sep.","10":"okt.","11":"nov.","12":"dec."}}}});
Globalize.a1068856757 = dateToPartsFormatterFn({"1":Globalize("da-DK").numberFormatter({"raw":"0"})}, {"pattern":"E d. MMM","timeSeparator":".","days":{"E":{"1":{"sun":"søn.","mon":"man.","tue":"tir.","wed":"ons.","thu":"tor.","fri":"fre.","sat":"lør."}}},"months":{"M":{"3":{"1":"jan.","2":"feb.","3":"mar.","4":"apr.","5":"maj","6":"jun.","7":"jul.","8":"aug.","9":"sep.","10":"okt.","11":"nov.","12":"dec."}}}});
Globalize.a1768127801 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"yyyy-MM-dd"}));
Globalize.a653581433 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"dd/MM/yyyy"}));
Globalize.b1479896308 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"d/M/yyyy"}));
Globalize.a1692617030 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"yyyy/M/d"}));
Globalize.a707722457 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"dd.MM.yyyy"}));
Globalize.a1268774158 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"d.M.yyyy"}));
Globalize.b1789522823 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"yyyy/MM/dd"}));
Globalize.a761863481 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"dd-MM-yyyy"}));
Globalize.a1291357753 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"MM/dd/yyyy"}));
Globalize.b1721467700 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"M/d/yyyy"}));
Globalize.b10697511 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"yyyy.MM.dd"}));
Globalize.a1142920070 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"EEEEE"}));
Globalize.a729574201 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"EEEE"}));
Globalize.b523671239 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"MMMM"}));
Globalize.b2122707385 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"d"}));
Globalize.a972425836 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"M/d/yy"}));
Globalize.a1294484693 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"skeleton":"MMMd"}));
Globalize.a1454958676 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"skeleton":"MMMMd"}));
Globalize.b83900191 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"skeleton":"yMMMMd"}));
Globalize.a828516895 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"skeleton":"yMMMM"}));
Globalize.a829202088 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"skeleton":"yMMMd"}));
Globalize.b1985877355 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"skeleton":"MMMEEEEd"}));
Globalize.a1447570508 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"skeleton":"MMMEd"}));
Globalize.b912777752 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy-MM-dd","digitsRe":/\d/});
Globalize.b2027324120 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd/MM/yyyy","digitsRe":/\d/});
Globalize.a2025689979 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d/M/yyyy","digitsRe":/\d/});
Globalize.a903236021 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/M/d","digitsRe":/\d/});
Globalize.b1973183096 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd.MM.yyyy","digitsRe":/\d/});
Globalize.a479393149 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d.M.yyyy","digitsRe":/\d/});
Globalize.b175461080 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/MM/dd","digitsRe":/\d/});
Globalize.b1919042072 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd-MM-yyyy","digitsRe":/\d/});
Globalize.b1389547800 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MM/dd/yyyy","digitsRe":/\d/});
Globalize.a1784118587 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yyyy","digitsRe":/\d/});
Globalize.a1603364232 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy.MM.dd","digitsRe":/\d/});
Globalize.b1345912457 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEEE","digitsRe":/\d/,"gregorian/days/format/narrow":[["sun",/^S/],["mon",/^M/],["tue",/^T/],["wed",/^O/],["thu",/^T/],["fri",/^F/],["sat",/^L/]]});
Globalize.b181994712 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE","digitsRe":/\d/,"gregorian/days/format/wide":[["tue",/^tirsdag/],["thu",/^torsdag/],["sun",/^søndag/],["mon",/^mandag/],["wed",/^onsdag/],["fri",/^fredag/],["sat",/^lørdag/]]});
Globalize.b1435240152 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^september/],["11",/^november/],["12",/^december/],["2",/^februar/],["10",/^oktober/],["1",/^januar/],["8",/^august/],["3",/^marts/],["4",/^april/],["6",/^juni/],["7",/^juli/],["5",/^maj/]]});
Globalize.a614472888 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d","digitsRe":/\d/});
Globalize.a1128028827 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yy","digitsRe":/\d/});
Globalize.b1701490106 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d. MMM","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["1",/^jan\./],["2",/^feb\./],["3",/^mar\./],["4",/^apr\./],["6",/^jun\./],["7",/^jul\./],["8",/^aug\./],["9",/^sep\./],["10",/^okt\./],["11",/^nov\./],["12",/^dec\./],["5",/^maj/]]});
Globalize.b1225946877 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d. MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^september/],["11",/^november/],["12",/^december/],["2",/^februar/],["10",/^oktober/],["1",/^januar/],["8",/^august/],["3",/^marts/],["4",/^april/],["6",/^juni/],["7",/^juli/],["5",/^maj/]]});
Globalize.b1587593710 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d. MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^september/],["11",/^november/],["12",/^december/],["2",/^februar/],["10",/^oktober/],["1",/^januar/],["8",/^august/],["3",/^marts/],["4",/^april/],["6",/^juni/],["7",/^juli/],["5",/^maj/]]});
Globalize.b1852388658 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^september/],["11",/^november/],["12",/^december/],["2",/^februar/],["10",/^oktober/],["1",/^januar/],["8",/^august/],["3",/^marts/],["4",/^april/],["6",/^juni/],["7",/^juli/],["5",/^maj/]]});
Globalize.b1851703465 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d. MMM y","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["1",/^jan\./],["2",/^feb\./],["3",/^mar\./],["4",/^apr\./],["6",/^jun\./],["7",/^jul\./],["8",/^aug\./],["9",/^sep\./],["10",/^okt\./],["11",/^nov\./],["12",/^dec\./],["5",/^maj/]]});
Globalize.a368629638 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE d. MMM","digitsRe":/\d/,"gregorian/days/format/wide":[["tue",/^tirsdag/],["thu",/^torsdag/],["sun",/^søndag/],["mon",/^mandag/],["wed",/^onsdag/],["fri",/^fredag/],["sat",/^lørdag/]],"gregorian/months/format/abbreviated":[["1",/^jan\./],["2",/^feb\./],["3",/^mar\./],["4",/^apr\./],["6",/^jun\./],["7",/^jul\./],["8",/^aug\./],["9",/^sep\./],["10",/^okt\./],["11",/^nov\./],["12",/^dec\./],["5",/^maj/]]});
Globalize.b1233335045 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"E d. MMM","digitsRe":/\d/,"gregorian/days/format/abbreviated":[["sun",/^søn\./],["mon",/^man\./],["tue",/^tir\./],["wed",/^ons\./],["thu",/^tor\./],["fri",/^fre\./],["sat",/^lør\./]],"gregorian/months/format/abbreviated":[["1",/^jan\./],["2",/^feb\./],["3",/^mar\./],["4",/^apr\./],["6",/^jun\./],["7",/^jul\./],["8",/^aug\./],["9",/^sep\./],["10",/^okt\./],["11",/^nov\./],["12",/^dec\./],["5",/^maj/]]});
module.exports = Globalize;
